/**
 * Turn a number of bytes into a human readable string with
 * the appropriate suffix, rounded to 2 decimal places.
 */
export const bytesToHumanReadable = (bytes) => {
    const levels = {
        BYTE: {
            singular: 'Byte',
            plural: 'Bytes',
            symbol: 'B',
            lowest: 0,
        },
        KILOBYTE: {
            singular: 'Kilobyte',
            plural: 'Kilobytes',
            symbol: 'KB',
            lowest: 1_000,
        },
        MEGABYTE: {
            singular: 'Megabyte',
            plural: 'Megabytes',
            symbol: 'MB',
            lowest: 1_000_000,
        },
        GIGABYTE: {
            singular: 'Gigabyte',
            plural: 'Gigabytes',
            symbol: 'GB',
            lowest: 1_000_000_000,
        },
        TERABYTE: {
            singular: 'Terabyte',
            plural: 'Terabytes',
            symbol: 'TB',
            lowest: 1_000_000_000_000,
        },
    };
    const level = Object.values(levels)
        .reverse()
        .filter((level) => bytes > level.lowest)?.[0];
    return `${(bytes / (level?.lowest || 1)).toFixed(2)} ${level?.symbol}`;
};
/**
 * Return a CSV string from an array of objects
 */
export const getCSVString = (objectArray, delimiter = ',') => {
    let csvString = '';
    // Get the headers
    let headers = Object.keys(objectArray?.[0] ?? {});
    csvString += headers.join(delimiter) + '\n';
    // Add the data
    objectArray.forEach((object) => {
        let data = headers
            .map((key) => {
            const val = object[key];
            const stringVal = JSON.stringify(val);
            return stringVal;
        })
            .join(delimiter);
        csvString += data + '\n';
    });
    return csvString;
};
/**
 * Download a file from raw data
 * * @see https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
 */
export const downloadFile = ({ fileData, filename, contentType, }) => {
    var blob = new Blob([fileData], { type: contentType });
    var url = URL.createObjectURL(blob);
    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    document.body.appendChild(pom);
    pom.click();
    document.body.removeChild(pom);
};
/**
 * Download contents as a file
 */
export const downloadCSV = (csvContent, filename) => {
    downloadFile({
        filename,
        fileData: csvContent,
        contentType: 'text/csv;charset=utf-8;',
    });
};
export const downloadPPTX = (pptContent, filename) => {
    downloadFile({
        filename,
        fileData: pptContent,
        contentType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    });
};
